export default "__VITE_ASSET__98a31d43__"